const FormStoreState = {
  isLoading: false,
  templates: [],
  workOrderForm: null,
  forms: [],
  formsToBeRemoved: [],
  workOrderFormId: undefined,
};

export default FormStoreState;
